import { useEffect, useState } from "react";
import axios from "axios";

export default function PendingBookings() {

  const [data, setData] =
    useState([]);

  const [statut, setStatut] =
    useState("pending");

  const [search, setSearch] =
    useState("");

  const [date, setDate] =
    useState("");

  const [page, setPage] =
    useState(1);

  const [totalPages, setTotalPages] =
    useState(1);

  const [total, setTotal] =
    useState(0);

  const [loading, setLoading] =
    useState(false);

  const limit = 5;

  useEffect(() => {
    fetchBookings();
  }, [
    statut,
    search,
    date,
    page
  ]);

  // =====================
  // FETCH
  // =====================

  const fetchBookings =
    async () => {

      try {

        setLoading(true);

        const res =
          await axios.get(
            "/api/public/payment/pending-bookings",
            {
              params: {
                statut,
                search,
                date,
                page,
                limit
              }
            }
          );

        setData(
          res.data.data || []
        );

        setTotalPages(
          res.data.totalPages || 1
        );

        setTotal(
          res.data.total || 0
        );

      } finally {

        setLoading(false);

      }
    };

  // =====================
  // PAY
  // =====================

  const pay = async (
    tx
  ) => {

    try {

      await axios.post(
        "/api/public/payment/notify",
        {
          cpm_trans_id: tx,
          cpm_trans_status:
            "ACCEPTED"
        }
      );

      alert(
        "Paiement simulé ✅"
      );

      fetchBookings();

    } catch (err) {

      console.error(err);

      alert(
        "Erreur paiement ❌"
      );

    }
  };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 min-h-[100dvh] bg-gray-100 space-y-4 md:space-y-6">

      {/* HEADER */}
      <h2 className="text-2xl md:text-3xl font-semibold">
        Pending Bookings
      </h2>

      {/* FILTERS */}
      <div className="bg-white rounded-2xl shadow p-4 flex flex-col md:flex-row md:flex-wrap gap-3">

        <button
          onClick={() => {
            setStatut(
              "pending"
            );

            setPage(1);
          }}
          className={`px-4 py-3 rounded-xl text-sm transition ${
            statut ===
            "pending"
              ? "bg-yellow-400"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Pending
        </button>

        <button
          onClick={() => {
            setStatut(
              "paid"
            );

            setPage(1);
          }}
          className={`px-4 py-3 rounded-xl text-sm transition ${
            statut === "paid"
              ? "bg-green-600 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Payé
        </button>

        <button
          onClick={() => {
            setStatut("all");

            setPage(1);
          }}
          className={`px-4 py-3 rounded-xl text-sm transition ${
            statut === "all"
              ? "bg-gray-700 text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          Tous
        </button>

        <input
          type="text"
          placeholder="Recherche nom ou TX"
          value={search}
          onChange={(e) => {
            setSearch(
              e.target.value
            );

            setPage(1);
          }}
          className="px-4 py-3 border rounded-xl outline-none focus:ring-2 focus:ring-blue-400 w-full md:w-72"
        />

        <input
          type="date"
          value={date}
          onChange={(e) => {
            setDate(
              e.target.value
            );

            setPage(1);
          }}
          className="px-4 py-3 border rounded-xl outline-none focus:ring-2 focus:ring-blue-400"
        />

      </div>

      {/* LOADING */}
      {loading && (

        <div className="text-sm text-gray-500">
          Chargement...
        </div>

      )}

      {/* MOBILE */}
      <div className="grid gap-3 md:hidden">

        {data.length === 0 ? (

          <div className="bg-white rounded-2xl shadow p-6 text-center text-gray-400">
            Aucun résultat trouvé
          </div>

        ) : (

          data.map((b, i) => (

            <div
              key={i}
              className="bg-white rounded-2xl shadow p-4 border"
            >

              <div className="flex justify-between gap-2 items-start">

                <span className="text-xs font-mono text-gray-500 break-all">
                  {b.transaction_id}
                </span>

                <span
                  className={`px-2 py-1 rounded text-xs whitespace-nowrap ${
                    b.statut ===
                    "paid"
                      ? "bg-green-100 text-green-700"
                      : "bg-yellow-100 text-yellow-700"
                  }`}
                >
                  {b.statut}
                </span>

              </div>

              <div className="mt-3 font-semibold break-words">
                {b.nom}{" "}
                {b.prenom}
              </div>

              <div className="mt-2 text-lg font-bold text-blue-600">
                {b.montant} $
              </div>

              <div className="mt-2 text-sm">

                Reste :{" "}

                <span
                  className={
                    Number(
                      b.reste || 0
                    ) === 0
                      ? "text-green-600 font-semibold"
                      : "text-red-500 font-semibold"
                  }
                >
                  {Number(
                    b.reste || 0
                  )}$
                </span>

              </div>

              <button
                disabled={
                  Number(
                    b.reste || 0
                  ) === 0
                }
                onClick={() =>
                  pay(
                    b.transaction_id
                  )
                }
                className={`mt-4 w-full px-4 py-3 rounded-xl transition ${
                  Number(
                    b.reste || 0
                  ) === 0
                    ? "bg-gray-300"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              >
                Payer
              </button>

            </div>

          ))

        )}

      </div>

      {/* DESKTOP */}
      <div className="hidden md:block overflow-x-auto bg-white rounded-2xl shadow">

        <table className="w-full text-sm">

          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">

            <tr>

              <th className="px-4 py-3 text-left">
                TX
              </th>

              <th className="px-4 py-3 text-left">
                Client
              </th>

              <th className="px-4 py-3 text-left">
                Montant
              </th>

              <th className="px-4 py-3 text-left">
                Statut
              </th>

              <th className="px-4 py-3 text-left">
                Reste
              </th>

              <th className="px-4 py-3 text-left">
                Action
              </th>

            </tr>

          </thead>

          <tbody>

            {data.length ===
            0 ? (

              <tr>

                <td
                  colSpan="6"
                  className="text-center py-6 text-gray-400"
                >
                  Aucun résultat trouvé
                </td>

              </tr>

            ) : (

              data.map(
                (
                  b,
                  i
                ) => (

                  <tr
                    key={i}
                    className="border-t hover:bg-gray-50"
                  >

                    <td className="px-4 py-3 text-xs font-mono">
                      {
                        b.transaction_id
                      }
                    </td>

                    <td className="px-4 py-3">
                      {b.nom}{" "}
                      {
                        b.prenom
                      }
                    </td>

                    <td className="px-4 py-3 font-semibold">
                      {b.montant}$
                    </td>

                    <td className="px-4 py-3">

                      <span
                        className={
                          b.statut ===
                          "paid"
                            ? "bg-green-100 text-green-700 px-2 py-1 rounded text-xs"
                            : "bg-yellow-100 text-yellow-700 px-2 py-1 rounded text-xs"
                        }
                      >
                        {b.statut}
                      </span>

                    </td>

                    <td className="px-4 py-3">

                      <span
                        className={
                          Number(
                            b.reste ||
                              0
                          ) === 0
                            ? "text-green-600"
                            : "text-red-500"
                        }
                      >
                        {Number(
                          b.reste ||
                            0
                        )}
                        $
                      </span>

                    </td>

                    <td className="px-4 py-3">

                      <button
                        disabled={
                          Number(
                            b.reste ||
                              0
                          ) === 0
                        }
                        onClick={() =>
                          pay(
                            b.transaction_id
                          )
                        }
                        className={`px-3 py-2 rounded transition ${
                          Number(
                            b.reste ||
                              0
                          ) === 0
                            ? "bg-gray-300"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                        }`}
                      >
                        Payer
                      </button>

                    </td>

                  </tr>

                )
              )

            )}

          </tbody>

        </table>

      </div>

      {/* PAGINATION */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-3">

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(
              (p) => p - 1
            )
          }
          className="px-4 py-2 bg-white rounded-xl shadow disabled:opacity-50"
        >
          Précédent
        </button>

        <div className="text-sm text-center">
          Page <b>{page}</b> /{" "}
          {totalPages} — {total} résultats
        </div>

        <button
          disabled={
            page ===
            totalPages
          }
          onClick={() =>
            setPage(
              (p) => p + 1
            )
          }
          className="px-4 py-2 bg-white rounded-xl shadow disabled:opacity-50"
        >
          Suivant
        </button>

      </div>

    </div>
  );
}